import api from "../services/api";

// หมายเหตุ: response interceptor ใน index.js แกะ response.data.result ให้แล้ว
// ดังนั้น r.data = payload ตรง ๆ ({ items, unreadCount } ฯลฯ)

export const fetchNotifications = (params = {}) =>
  api.get("api/notification", { params }).then((r) => r.data);

export const fetchUnreadCount = () =>
  api.get("api/notification/unread-count").then((r) => r.data);

export const markNotificationRead = (id) =>
  api.patch(`api/notification/${id}/read`).then((r) => r.data);

export const markAllNotificationsRead = () =>
  api.patch("api/notification/read-all").then((r) => r.data);

// URL ของ SSE stream — EventSource ตั้ง Authorization header ไม่ได้ จึงส่ง token ทาง query
// baseURL ถูกเซ็ตตอน bootstrap (App.js -> setDefaultURL) อ่านจาก instance โดยตรง
export function getNotificationStreamUrl(token) {
  const base = (api.defaults.baseURL || "").replace(/\/$/, "");
  return `${base}/api/notification/stream?token=${encodeURIComponent(token)}`;
}
